// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const log = (...args: any[]) => {
  // eslint-disable-next-line no-console
  console.error('AnimateCC:', ...args);
};
